import { createToaster } from "@meforma/vue-toaster";
import {
  humanizeApiError,
  isCancelError,
  noResponseMessage,
  translateDetail,
  translateFieldMessage,
} from '@/backend/errorMessages';



export function useErrorHandler(error) {
  const toaster = createToaster();
  let path = null
  if (isCancelError(error)) return path
  if (error.response) {
    // Ошибка от сервера (код ответа не в диапазоне 2xx)
    const status = error.response.status;
    const data = error.response.data;
    const detail = data && data.detail;

    if (status === 401) {
      path = '/login'
      toaster.error(translateDetail(detail) || 'Сессия истекла, войдите заново');
    } else if (status === 422 && Array.isArray(detail)) {
      const errorMessages = detail.map((error) => {
        const { loc = [], msg } = error;
        const field = loc.length ? loc.join('.') : '';
        const text = translateFieldMessage(msg);
        return field ? `${field.replace('body.', '')}: ${text}` : text;
      });
      toaster.error(errorMessages.join('\n'));
    } else {
      toaster.error(humanizeApiError(error));
    }
  } else if (error.request) {
    // Нет ответа сервера (пропал интернет, сервер не ответил вовремя).
    // Человека не уводим со страницы: раньше здесь был переход на главную,
    // и при коротком сбое терялись открытый экран и фильтры.
    console.warn('Request error:', error.technicalMessage || error.message, error.request);
    toaster.error(noResponseMessage(error));
  } else {
    console.warn('Error:', error.technicalMessage || error.message);
    toaster.error('Ошибка при выполнении запроса');
  }

  return path; // Пробрасываем путь

}
